type ClassValue = string | false | null | undefined;

export function mergeClasses(...values: ClassValue[]) {
  return values.filter((value): value is string => Boolean(value)).join(' ');
}
